import * as _ from "lodash"
import { MessageType } from "../PA.Core/PA.Core.IF.Basic"
import {} from "../PA.Core/PAdbSchemaRows"
import { FundingRuleBO } from "./FundingRuleBO"


export class FundingRuleBOValidations {

    static async ValidateFields(aBO: FundingRuleBO): Promise<void> {

        if (!aBO.WB_FundingRule.isActive)
            return

        if (_.isEmpty(aBO.WB_FundingRule.cif.FUNDING_RULE_ID) || _.isNull(aBO.WB_FundingRule.cif.FUNDING_RULE_ID)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: "EmptyId",
                    type: MessageType.Error,
                    title: "Funding Rule ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyId")
        }

        if (_.isEmpty(aBO.WB_FundingRule.cif.FUNDING_RULE_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: "Emptyname",
                    type: MessageType.Warning,
                    title: "Rule Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage("Emptyname")
        }

        if (!_.isEmpty(aBO.Pending_Rule_Set) && _.filter(aBO.Pending_Rule_Set.Funding_Rule_Set_Relationships, r => r.isActive).length > 0 && _.isUndefined(aBO.Pending_Rule_Set.PendingValidityDt)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: "EmptyValidityDate",
                    type: MessageType.Warning,
                    title: "Pending Rule Set has no validity date",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyValidityDate")
        }
    }
}
